import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';

import * as AdminActions from '../../store/actions/adminActions';
import SidebarLink from './SidebarLink';

class ConsoleSidebar extends Component {

    componentDidMount(){
        this.props.getCoursesByToken(this.props.user.id, this.props.match.params.courseId);

    }

    componentDidUpdate(props){
        // console.log(props.match.params.courseId, this.props.match.params.courseId);
        if(props.match.params.courseId !== this.props.match.params.courseId){
            // Set to:
            if (this.props.adminCourses) {
                let courseFound = false;
                this.props.adminCourses.map(c => {
                    if(c.id === this.props.match.params.courseId){
                        courseFound = true;
                        this.props.setCurrentCourse(c);
                    }
                })
                if(!courseFound){
                    this.props.setCurrentCourse({});
                }
            }
        }
    }

    render(){
        const tabbedViews = ["flags", "subject-failure", "lecture-failure", "upcoming-tests", "attendance", "quiz-average"];
        let showTabs = tabbedViews.indexOf(this.props.match.params.view) > -1;
        return (
            <div className="dashboard-menu">
                <div className="course-switcher">
                    <div className="dropdown">
                        <a href="#" className="btn btn-default btn-block" data-toggle="dropdown">{
                            this.props.match.params.courseId && this.props.adminCourses ?
                                this.props.adminCourses.filter(c => c.id === this.props.match.params.courseId)[0] ? 
                                this.props.adminCourses.filter(c => c.id === this.props.match.params.courseId)[0].name
                                    : 'All'
                                : 'All'
                            } <i className="fa fa-caret-down"></i></a>
                            <ul className="dropdown-menu">
                            <li><Link to={`/admin/${this.props.match.params.view}`}>All </Link></li>
                                {this.props.adminCourses ?
                                    this.props.adminCourses.map(c => {
                                        return <li><Link to={`/admin/${c.id}/${this.props.match.params.view}`}>{c.name} </Link></li>
                                    })
                                : ''}
                            </ul>
                    </div>
                </div>
                <div className="dashboard-menu-link-section">
                    <SidebarLink courseId={this.props.match.params.courseId} view="engagement" className="level-1-menu-item" title="Course Dashboard" />

                </div>

                <div className="dashboard-menu-link-section activeSideItem">
                    <SidebarLink courseId={this.props.match.params.courseId} view="analytics" className="level-1-menu-item" title="Analytics" />
                </div>
                <div className="dashboard-menu-link-section">
                    <SidebarLink courseId={this.props.match.params.courseId} view="students" className="level-1-menu-item" title="Students" />

                </div>
                <div className="dashboard-menu-link-section">
                    <SidebarLink courseId={this.props.match.params.courseId} view="#" className="level-1-menu-item" title="Student Alerts" />
                    <ul>
                        <li><SidebarLink courseId={this.props.match.params.courseId} view="flags" title="Red Flags" /></li>
                        <li><SidebarLink courseId={this.props.match.params.courseId} view="subject_failure" title="Subject Failure" /></li>
                        <li><SidebarLink courseId={this.props.match.params.courseId} view="lecture_failure" title="Lecture Failure" /></li>
                        <li><SidebarLink courseId={this.props.match.params.courseId} view="upcoming_tests" title="Upcoming Tests" /></li>
                        <li><SidebarLink courseId={this.props.match.params.courseId} view="attendance" title="Attendance" /></li>
                        <li><SidebarLink courseId={this.props.match.params.courseId} view="quiz_average" title="Quiz Average" /></li>
                    </ul>
                </div>
                <div className="dashboard-menu-link-section">
                    <a href="#" className="level-1-menu-item">Critical Alerts</a>
                    <ul>
                        <li><a href="dashbaord-dual-login.php">Dual Login</a></li>
                        <li><a href="dashbaord-screenshots.php">Screenshots</a></li>
                        <li><a href="dashbaord-multiple-locations.php">Multiple Locations</a></li>
                    </ul>
                </div>
                {/*
                <div className="dashboard-menu-link-section">
                    <a href="#" className="level-1-menu-item">Reported</a>
                    <ul>
                        <li><a href="dashbaord-bugs.php">Bugs</a></li>
                        <li><a href="dashbaord-comments.php">Comments</a></li>
                        <li><a href="dashbaord-missed-messages.php">Missed Messages</a></li>
                        <li><a href="dashbaord-cancelled-courses.php">Cancellled Course</a></li>
                        <li><a href="dashbaord-failing-courses.php">Failing Course</a></li>
                        <li><a href="dashbaord-page-not-load.php">Page didn't load</a></li>
                    </ul>
                </div>
                */}
                <div className="dashboard-menu-link-section">
                    <SidebarLink courseId={this.props.match.params.courseId} view="comments" className="level-1-menu-item" title="Comments" />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getCoursesByToken: (token, courseId) => {
        dispatch(AdminActions.getCoursesByToken(token, courseId));
    },
    setCurrentCourse: (course) => {
        dispatch(AdminActions.setCurrentCourse(course));
    }
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ConsoleSidebar));



// WEBPACK FOOTER //
// ./src/components/AdminConsole/ConsoleSidebar.js